export default {
    dayNames: [
        'niedziela', 'poniedziałek', 'wtorek', 'środa',
        'czwartek', 'piątek', 'sobota'
    ],
    dayNamesShort: ['ndz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
    dayNamesMin: ['N', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],

    monthNames: [
        'styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec',
        'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'
    ],
    monthNamesShort: [
        'sty', 'lut', 'mar', 'kwi', 'maj', 'cze',
        'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'
    ],

    today: 'Dzisiaj',
    clear: 'Wyczyść',
    weekHeader: 'Tydz.',
    weak: 'Słaby',
    medium: 'Średni',
    strong: 'Silny',
    passwordPrompt: 'Podaj hasło',
    emptyFilterMessage: 'Brak wyników',
    emptyMessage: 'Brak dostępnych opcji',

    dateFormat: 'yy-mm-dd',

    // IMPORTANT — Monday as first day of week
    firstDayOfWeek: 1,

    // TimePicker
    apply: 'Zastosuj',
    cancel: 'Anuluj',

    // DateRange picker additional strings
    chooseDate: 'Wybierz datę',
    chooseTime: 'Wybierz godzinę',
    prevMonth: 'Poprzedni miesiąc',
    nextMonth: 'Następny miesiąc',
    prevYear: 'Poprzedni rok',
    nextYear: 'Następny rok',
};
